import { get } from 'lodash'
import { useCallback, useState } from 'react'

type TUseInput = {
  value?: string
  onChange?: (val: string) => void
  reset?: () => void
}

const useInput = (initialValue: string): TUseInput => {
  const [value, setValue] = useState(initialValue)

  const onChange = useCallback(
    (event) => setValue(get(event, 'target.value', event)),
    [],
  )

  const reset = useCallback(() => setValue(''), [])

  return {
    value,
    onChange,
    reset,
  }
}

export default useInput
